/**
 * localStorage keys used to persist auth session state.
 */
export const AuthConstants = {
  TOKEN_KEY: 'amaalmomineen-token'
} as const;
